/**
 * This enum is used to define the view mode for date picker
 */
export enum DatePickerMode {
  /**
   * The Years view mode
   */
  Years = 'years',

  /**
   * The months view mode
   */
  Months = 'months',

  /**
   * The days view mode
   */
  Days = 'days',
}
